import React from "react"
import { HeartIcon } from "@heroicons/react/outline"
export default function HeadCard({ data, wish }) {
  return (
    <div className=" w-full  mx-auto">
      <div className="p-2 lg:p-8 container mx-auto grid gap-4 sm:gap-0 sm:flex justify-between items-center pt-10">
        <div className="grid gap-2">
          <h1 className="font-normal">{data.title || data.name}</h1>
          {data.subTitle && <h2 className="text-gray-500">{data.subTitle}</h2>}
        </div>

        {wish && (
          <div className="grid gap-4 md:gap-0 md:flex md:space-x-6">
            <button className="text-gray-400 flex space-x-2 items-center">
              <span>Add to wishlist</span>{" "}
              <HeartIcon className="h-10 w-10 text-black" />
            </button>
            <button className="border border-red-600 text-red-600 w-40 h-10 justify-center items-center text-sm font-bold hover:bg-red-500 hover:text-white transition ease-in-out duration-300">
              Book Now
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
